import { Component, OnDestroy, OnInit } from '@angular/core'; 
import { UserService } from '../../services/user.service';
import { BancoldexService } from 'src/app/comun/services/bancoldex.service';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';
import { Subscription } from 'rxjs';
import { CookieConsentService } from 'src/app/shared/cookie-consent/cookie-consent.service';
//Constantes
const ParametroURLVideoFormulario = 'PAR-101';
const ParametroURLVideoDocumentos = 'PAR-102';
@Component({
    selector: 'app-solicitud',
    templateUrl: './solicitud.component.html',
    standalone: false
})
export class SolicitudComponent implements OnInit, OnDestroy{
    isExpress: boolean = false;
    isFile: boolean = false;
    subTitle : string = "Para realizar una solicitud completa lo siguientes campos";
    isNatural : boolean;
    urlVideoDocumentos: any;
    urlVideoFormulario: any;
    idEstadoSolicitud: number;
    youtubeConsent = false;
    private consentSub: Subscription | null = null;

    constructor(private userService: UserService,
        private _bancoldexService: BancoldexService,        
        private _sweetAlert:SweetAlertService,
        private readonly cookieConsent: CookieConsentService) {}

    ngOnInit(){
        this.consentSub = this.cookieConsent.state$.subscribe(() => {
            this.youtubeConsent = this.cookieConsent.isProviderAccepted('youtube');
        });
        var json = {
            idParametro: ParametroURLVideoDocumentos,
            nombre: null,
            isParFuncional: true,
            pagina: 1,
        };
        this._bancoldexService.getFilterParametro(json).subscribe(
            (resp: any) => {
                if(resp.exitoso) {                    
                    this.urlVideoDocumentos = resp.data[0].valorParametro;
                } 
            },
            (error) => {
                this._sweetAlert.errorModal("Error!",true,error.error);
            }
        );
        var json = {
            idParametro: ParametroURLVideoFormulario,
            nombre: null,
            isParFuncional: true,
            pagina: 1,
        };
        this._bancoldexService.getFilterParametro(json).subscribe(
            (resp: any) => {
                if(resp.exitoso) {                    
                    this.urlVideoFormulario = resp.data[0].valorParametro;
                }               
            },
            (error) => {
                this._sweetAlert.errorModal("Error!",true,error.error);
            }
        );
        this.isNatural = this.userService.getUser().tipoPersona === "natural" ? true : false;
    }

    ngOnDestroy(): void {
        this.consentSub?.unsubscribe();
    }

    changeToFiles(evento){
        this.idEstadoSolicitud = evento.estado;
        if(evento.tipo == 'express'){
           this.isExpress = true;
        }else{
            this.isExpress = false;
        }
        this.isFile = true;
        this.subTitle = "Anexa la siguiente información como soporte para "+
            "continuar con tu solicitud.";
    }

    changeToForm($event){
        this.isFile = false;
        this.subTitle = "Para realizar una solicitud completa lo siguientes campos";
    }
}